import { render, staticRenderFns } from "./CommunicationPopUpModal.vue?vue&type=template&id=256aa652&scoped=true"
import script from "./CommunicationPopUpModal.vue?vue&type=script&lang=js"
export * from "./CommunicationPopUpModal.vue?vue&type=script&lang=js"
import style0 from "./CommunicationPopUpModal.vue?vue&type=style&index=0&id=256aa652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256aa652",
  null
  
)

export default component.exports